module.exports = __webpack_public_path__ + "static/media/viziyaLogoSmall.15b943cd.svg";